import * as React from 'react'
import styled from 'styled-components'
import type { FontPropsType, TextAlignType } from '../components/shared/typography'
import { Container, Col, Row, config, Hidden } from 'react-awesome-styled-grid'
import { P, SectionTitle, Section2Header } from './shared/typography'
import { colors } from './shared/colors'
import { OutlineOnFocusVisible } from './shared/buttons'

type AccordionInfoType = {
  title: string,
  content: string
}

export default function WeBelieveAccordion (): React.ReactNode {
  const [activeContent, setActiveContent] = React.useState(0)
  const [arrowLocation, setArrowLocation] = React.useState(0)

  const idTargetName = 'accordion-container'
  const singleTargetRootName = 'accordion-title'
  const accordionItems = [
    {
      title: 'A new standard',
      content: 'We know how complex desire can be—which is why our diverse team of professional writers and voice actors bring our erotic stories to life in vivid color, with characters so fully-realized, you can almost feel them. ;) Let Dipsea\'s steamy storylines, irresistible voices, immersive sound design, and personalized user experience sweep you off your feet.'
    },
    {
      title: 'Safe and empowering',
      content: 'An erotic universe that never sacrifices safety, the Dipsea platform is a safe space to explore your desires. We take care of our characters—and our listeners!—and thoughtfully depict love, sex, and intimacy in empowering ways. No matter how rough and wild things get! Plus, all stories are tagged and categorized so you know what to expect from them.'
    },
    {
      title: 'For the female gaze',
      content: 'We create stories that cater to the female gaze. In a world built by and for men, our stories offer a fresh, nuanced perspective for people of all identities to enjoy.'
    }
  ]

  const changeActiveContent = (index: number): void => {
    const buttonElement = document.getElementById(`${singleTargetRootName}-${index}`)
    const newLocation = buttonElement ? buttonElement.offsetTop : 0
    setArrowLocation(newLocation)
    setActiveContent(index)
  }

  return (
    <Container fluid={true}>
      <Row align='start' justify='center' className="row">
        <Col lg={5} xl={4} offset={{ md: '1', lg: '0', xl: '1' }}>
          <OurBeliefsTitle color={colors.white}>WHAT WE DO</OurBeliefsTitle>
        </Col>
        <Col lg={7} xl={7} />
      </Row>
      <Row align='start' justify='center' className="row">
        <Col md={2} lg={5} xl={4} offset={{ md: '1', lg: '0', xl: '1' }}>
          <SubHeader color={colors.white}>We’re creating</SubHeader>
        </Col>
        <Col md={5} lg={7} xl={7}>
          <Row>
            <SpaceDiv id={idTargetName} arrowLocation={arrowLocation}>
              {accordionItems.map((accordionItem: AccordionInfoType, index: number): React.ReactNode => {
                return (
                  <AccordionButton
                    key={`${singleTargetRootName}-${index}`}
                    id={`accordion-title-${index}`}
                    onClick={(): void => changeActiveContent(index)}
                    aria-expanded={index === activeContent}
                    aria-controls={`section-${index}`}
                    className={index === activeContent ? `active active-${index}` : undefined}
                  >
                    <span>{accordionItem.title}</span>
                  </AccordionButton>
                )
              })}
              <ArrowIndicator arrowLocation={arrowLocation}>
                <svg width="58" height="44" viewBox="0 0 58 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <line x1="8.74228e-08" y1="23.2082" x2="57.4164" y2="23.2082" stroke={colors.white} />
                  <path d="M57.4196 22.9721C46.0365 22.9721 36.8086 13.0851 36.8086 0.88887" stroke={colors.white} />
                  <path d="M57.4196 22.9721C46.0365 22.9721 36.8086 32.2 36.8086 43.5831" stroke={colors.white} />
                </svg>
              </ArrowIndicator>
            </SpaceDiv>
          </Row>
          <Hidden md>
            <Row>
              <UnderlinedDiv />
            </Row>
            <Row>
              <AccordionRegionWrapper>
                <AccordionRegion>
                  {accordionItems.map((accordionItem: AccordionInfoType, index: number): React.ReactNode => {
                    return (
                      <AccordionContent
                        key={`accordion-region-${index}`}
                        id={`section-${index}`}
                        role="region"
                        aria-labelledby={`accordion-title-${index}`}
                        className={index === activeContent ? 'active' : undefined}
                      >
                        <Text className={index === activeContent ? 'active' : undefined}>{accordionItem.content}</Text>
                      </AccordionContent>
                    )
                  })}
                </AccordionRegion>
              </AccordionRegionWrapper>
            </Row>
          </Hidden>
        </Col>
      </Row>
      <Hidden xs sm lg xl>
        <Row>
          <UnderlinedDiv />
        </Row>
        <Row>
          <AccordionRegionWrapper>
            <AccordionRegion>
              {accordionItems.map((accordionItem: AccordionInfoType, index: number): React.ReactNode => {
                return (
                  <AccordionContent
                    key={`accordion-region-${index}`}
                    id={`section-${index}`}
                    role="region"
                    aria-labelledby={`accordion-title-${index}`}
                    className={index === activeContent ? 'active' : undefined}
                  >
                    <Text className={index === activeContent ? 'active' : undefined}>{accordionItem.content}</Text>
                  </AccordionContent>
                )
              })}
            </AccordionRegion>
          </AccordionRegionWrapper>
        </Row>
      </Hidden>
    </Container>
  )
}

const OurBeliefsTitle = styled(SectionTitle)<any>`
  ${(props: any): any => config(props).media.md`
    margin-bottom: 20px;
  `}
  ${(props: any): any => config(props).media.lg`
    margin-bottom: 24px;
  `}
`
const ArrowIndicator = styled.div<any>`
  position: absolute;
  top: 0;
  left: calc(-30px - 19px);
  opacity: 1;
  will-change: transform, opacity;
  transition: opacity .2s ease-in-out, transform .8s cubic-bezier(0.32, 0.49, 0, 0.89) .1s;
  height: 34px;
  width: auto;
  display: flex;
  align-items: center;
  > svg {
    width: 30px;
  }
  ${(props: any): any => config(props).media.lg`
    left: calc(-57px - 26px);
    height: 66px;
    > svg {
      width: unset;
    }
  `}
  ${(props: any): any => config(props).media.xl`
    left: calc(-57px - 57px);
  `}
`

const SpaceDiv = styled.div<any>`
  margin: 0 20px 2px 96px;
  width: 100%;
  position: relative;
  ${ArrowIndicator} {
    opacity: 1;
    top: 0px;
    transform: translate3d(0, ${(props: any): number => props.arrowLocation}px,0);
  }

  ${(props: any): any => config(props).media.md`
    margin-top: 63px;
    margin-bottom: 6px;
    margin-left: 12px;
  `}
  ${(props: any): any => config(props).media.lg`
    margin: 0 0 70px 16px;
  `}
  ${(props: any): any => config(props).media.xl`
    margin: 0 0 70px 22px;
  `}
`

const AccordionButton = styled.button<any>`
  color: ${colors.white};
  cursor: pointer;
  font-family: 'Queens Condensed Light';
  font-style: normal;
  font-weight: ${(props: FontPropsType): number => props.fontWeight || 300};
  letter-spacing: ${(props: FontPropsType): number => props.letterSpacing || 0};
  text-align: ${(props: FontPropsType): TextAlignType => props.textAlign || 'left'};
  margin: 0;
  font-size: 28px;
  line-height: 34px;
  margin-bottom: 19px;
  background: none;
  position: relative;
  width: 100%;
  outline: none;
  border: none;
  ${OutlineOnFocusVisible};
  border-radius: 10px;
  transform: translateZ(0);
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0;
  display: inline;
  ${(props: any): any => config(props).media.lg`
    font-size: 60px;
    line-height: 66px;
    margin-bottom: 19px;
  `}
  > span {
    position: relative;
    transform: translateZ(0);
    display: inline;
    will-change: background-size;
    background: linear-gradient(to right,rgb(255 255 255 / 0%),rgb(255 255 255 / 0%)),linear-gradient(to right,rgb(255 255 255 / 80%),rgb(255 255 255 / 80%),rgb(255 255 255 / 80%));
    background-size: 100% 1px, 0 1px;
    background-position: 100% 100%, 0 100%;
    background-repeat: no-repeat;
    transition: background-size 500ms;
    transition-delay: .2s;
  }
  &.active,
  &:hover {
    > span {
      background-size: 0 1px, 100% 1px;
    }
  }
`

const UnderlinedDiv = styled.div<any>`
  position: relative;
  width: 100%;
  margin: 0px 8px 25px;
  transform: translateZ(0);
  ${(props: any): any => config(props).media.md`
    margin: 0px 103px 24px 103px;
  `}
  ${(props: any): any => config(props).media.lg`
    margin: 0px 30px 30px 18px;
  `}
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background-color: ${colors.white};
  }
`
const Text = styled(P)<any>`
  font-size: 16px;
  line-height: 24px;
  color: ${colors.white};
  margin-bottom: 30px;
  ${(props: any): any => config(props).media.md`
    margin-bottom: 25px;
  `}
  ${(props: any): any => config(props).media.lg`
    font-size: 18px;
    line-height: 27px;
  `}
`
const AccordionRegionWrapper = styled.div<any>`
  margin: 0 8px 40px;
  width: 100%;
  ${(props: any): any => config(props).media.md`
    margin: 0 103px 0px;
  `}
  ${(props: any): any => config(props).media.lg`
    margin: 0 18px 55px;
  `}
  ${(props: any): any => config(props).media.xl`
    margin: 0 18px 30px;
  `}
`
const AccordionRegion = styled.div<any>`
  position: relative;
  width: 100%;
  min-height: 200px;
`
const AccordionContent = styled.div<any>`
  will-change: opacity, filter;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  opacity: 0;
  filter: blur(5px);
  transition: opacity 1.5s ease-in-out, filter 2s ease-in-out;
  transform: translate3d(0,0,0);
  &.active {
    opacity: 1;
    filter: blur(0);
  }

`
const SubHeader = styled(Section2Header)<any>`
  font-size: 36px;
  line-height: 43px;
  margin-bottom: 21px;
  ${(props: any): any => config(props).media.lg`
    font-size: 60px;
    line-height: 66px;
  `}
`
